import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  initScrollDepthTracking,
  initOutboundClickTracking,
  trackEvent,
} from "@/lib/analytics";

/**
 * Site-wide analytics bootstrapper.
 * - Initializes outbound-click tracking once.
 * - Re-arms scroll-depth tracking on every route change so each page can
 *   contribute engagement events (which is what GA4 uses to compute bounce rate).
 * - Fires a lightweight `page_view` event on route change for SPA navigation.
 * - Fires a `time_on_page_15s` engagement ping if the user stays 15s+.
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const outboundInitialized = useRef(false);

  useEffect(() => {
    if (!outboundInitialized.current) {
      initOutboundClickTracking();
      outboundInitialized.current = true;
    }
  }, []);

  useEffect(() => {
    initScrollDepthTracking();
    trackEvent("page_view_spa", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });

    const dwellTimer = window.setTimeout(() => {
      trackEvent("engaged_dwell_15s", { page_path: location.pathname });
    }, 15000);

    return () => window.clearTimeout(dwellTimer);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
